import { Injectable } from '@angular/core';
import { last } from '@sama/micro-dash';
import { vectorTaggingToolsConfig } from '../../../../cross-team-shared/tools.config';
import {
  Point2D,
  ShapeLocation,
} from '../../../../team-apis/otterdam/answers/shape-typings';
import { isValidPartialCuboid } from '../../shapes/cuboid/cuboid-solver';
import { AbstractShapeTool2D } from '../shared/abstract-shape-tool-2d';
import {
  MultiClickShapeTool,
  MultiClickShapeToolHelper,
} from '../shared/tool-helpers/multi-click-shape-tool-helper';

@Injectable()
export class CuboidTool2D
  extends AbstractShapeTool2D
  implements MultiClickShapeTool
{
  readonly name = vectorTaggingToolsConfig.Cuboid.name;
  protected readonly shapeType = 'cuboid';

  override async onActivate() {
    await super.onActivate();
    this.onEvent('container', 'mousedown', () => {
      this.registerHelper(
        new MultiClickShapeToolHelper(
          this,
          this.store('vectorOverlay'),
          this.injector,
        ),
      );
    });
  }

  updateLocationToFollowMouse(location: ShapeLocation<Point2D>) {
    const numPoints = location.points.length;
    let point = this.getBoundedImagePoint();
    if (numPoints === 5) {
      point = alignWithMiddlePoint(point, location.points);
    }
    location.points[numPoints - 1] = point;
  }

  handleInProgressMouseDown(
    helper: MultiClickShapeToolHelper,
    event: MouseEvent,
  ) {
    const points = helper.getPointsStore().state();

    if (!isValidPartialCuboid(points)) {
      return;
    } else if (points.length === 5) {
      void helper.stopListening(event);
      return;
    }

    let clickedPoint = last(points);
    if (points.length === 4) {
      clickedPoint = alignWithMiddlePoint(clickedPoint, points);
    }
    helper.addPoint(clickedPoint);
    helper.trackAddInProgressSubpointEvent(points.length - 1);
  }
}

/**
 * Snap point to same x value as bottom middle point
 */
function alignWithMiddlePoint(
  point: Point2D,
  currentPoints: Point2D[],
): Point2D {
  return [currentPoints[2][0], point[1]];
}
